<template>
    <sa-page-layout :btnSaveVisible="true" :btnSaveNotBackVisible="false" :linkNotBack="linkNotBack" @aftersave="onAfterSave" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="table-body">
            <div class="sa-tab-scroll">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-card class="sa-card" header="Testata" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <label class="sa-label-data">Numero:</label>
                                    <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                                    <span class="sa-data">{{ jsonData.ordineOrigine.numero }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <label class="sa-label-data">Descrizione:</label>
                                    <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                                    <span class="sa-data">{{ jsonData.ordineOrigine.descrizioneAnagrafica }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <label class="sa-label-data">Note:</label>
                                    <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                                    <span class="sa-data">{{ jsonData.ordineOrigine.noteAnagrafica }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Codice Intestatario:</label>
                                    <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                                    <span class="sa-data">{{ jsonData.ordineOrigine.anagrafica.codice }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Nominativo Intestatario:</label>
                                    <span class="sa-data">{{ jsonData.ordineOrigine.anagrafica.nominativo }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Codice Fiscale:</label>
                                    <span class="sa-data">{{ jsonData.ordineOrigine.anagrafica.codiceFiscale }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">P. Iva:</label>
                                    <span class="sa-data">{{ jsonData.ordineOrigine.anagrafica.partitaIva }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Citta:</label>
                                    <span class="sa-data">{{ jsonData.ordineOrigine.anagrafica.citta }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Indirizzo:</label>
                                    <span class="sa-data">{{ jsonData.ordineOrigine.anagrafica.indirizzo }}</span>
                                </b-col>
                            </b-row>
                            <!-- <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                            <label class="sa-label-data">Attivo</label>
                        </b-form-checkbox>
                    </b-col>
                </b-row> -->
                        </b-card>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <b-card class="sa-card" header="Documento Origine" header-tag="header" footer-tag="footer" title="">
                            <b-card class="sa-card" header="Righe" header-tag="header" footer-tag="footer" title="">
                                <b-table sticky-header ref="table" :key="listKey" stacked="lg" striped hover :items="jsonData.ordineOrigine.listaRighe" :fields="fields" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light">
                                    <template #cell(index)="row">
                                        {{ row.index + 1 }}
                                    </template>
                                    <template #cell(actions)="row">
                                        <b-button v-if="!row.item.trasformata" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onTrasforma(row)">
                                            <i class="bi bi-arrow-bar-right"></i>
                                        </b-button>
                                    </template>
                                </b-table>
                            </b-card>
                            <b-card class="sa-card" header="Totali" header-tag="header" footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Importo Lordo:</label>
                                        <span class="sa-data">{{ jsonData.ordineOrigine.importoLordo }}</span>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Importo Netto:</label>
                                        <span class="sa-data">{{ jsonData.ordineOrigine.importoNetto }}</span>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Importo Iva:</label>
                                        <span class="sa-data">{{ jsonData.ordineOrigine.importoIva }}</span>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <b-card class="sa-card" header="Nuovo Documento" header-tag="header" footer-tag="footer" title="">
                            <b-card class="sa-card" header="Righe" header-tag="header" footer-tag="footer" title="">
                                <b-table sticky-header ref="table" stacked="lg" striped hover :key="listKey" :items="jsonData.listaRighe" :fields="fields" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light">
                                    <template #cell(index)="row">
                                        {{ row.index + 1 }}
                                    </template>
                                </b-table>
                            </b-card>
                            <b-card class="sa-card" header="Totali" header-tag="header" footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Importo Lordo:</label>
                                        <b-form-input v-model="jsonData.importoLordo" disabled></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Importo Netto:</label>
                                        <b-form-input v-model="jsonData.importoNetto" disabled></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Importo Iva:</label>
                                        <b-form-input v-model="jsonData.importoIva" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import RsaAccettazioneEditComponent from "../components/RsaAccettazioneEditComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/documenti",
            linkback: "/papercleandocumentotipi",
            linkNotBack: "/papercleandocumentotipi",
            jsonData: {
                tipo: "",
                dataOra: null,
                importoNetto: 0.0,
                importoNettoAggiuntivo: 0.0,
                importoIva: 0.0,
                importoLordo: 0.0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                documentoOrigine: "",
                listaRighe: [],
                ordineOrigine: { tipo: "", dataOra: null, importoNetto: 0.0, importoNettoAggiuntivo: 0.0, importoIva: 0.0, importoLordo: 0.0, statoAttuale: "", statoAttualeDataOra: null, idAnagrafica: "", listaRighe: [], anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] } },
                anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
            },
            documentoOrigine: {
                tipo: "",
                dataOra: null,
                importoNetto: 0.0,
                importoNettoAggiuntivo: 0.0,
                importoIva: 0.0,
                importoLordo: 0.0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [],
                anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
            },
            newLink: null,
            componentKey: 0,
            listKey: 0,
            btnNuovaPersonaRiferimento: true,
            btnNuovaRicetta: true,
            btnDatiFatturazione: true,
            btnNuovaImpegnativa: true,
            btnNuovoAllegatoA: true,
            btnSpesaExtra: true,
            id: null,
            idDocumento: null,
            trasformare: null,
            nuovoTipo: null,
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizioneArticolo",
                    // thStyle: "width: 20rem",
                    // sortable: true,
                },
                {
                    label: "Q.ta",
                    key: "quantita",
                    thStyle: "width: 8rem",
                    // sortable: true,
                },
                {
                    label: "P.zo Un.",
                    key: "prezzoUnitario",
                    thStyle: "width: 8rem",
                    // sortable: true,
                },
                {
                    label: "A.qta Iva",
                    key: "aliquotaIva",
                    thStyle: "width: 8rem",
                    // sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", thStyle: "width: 5rem" },
            ],
        };
    },
    created() {
        let me = this;
        me.id = this.$route.params.id;
        me.idDocumento = this.$route.query.idDocumento;
        me.jsonData.documentoOrigine = this.$route.query.idDocumento;
    },

    // watch: {
    //     id: {
    //         handler(newId) {
    //             if (newId !== "-1") {
    //                 let me = this;
    //                 console.log("VERO");

    //                 me.loadData();
    //             } else {
    //                 console.log("CIAO");
    //             }
    //         },
    //         //  immediate: false,
    //     },
    // },

    // computed: {
    //   id() {
    //     let me = this;

    //     return (me.id = me.$route.params.id);
    //   },
    // },
    mounted() {
        let me = this;
        /* me.id = this.$route.params.id; */
        me.id = this.$route.params.id;
        me.idDocumento = this.$route.query.idDocumento;
        me.trasformare = this.$route.query.trasformare;
        me.nuovoTipo = this.$route.query.nuovoTipo;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            let path = "";
            let tipo = this.$route.query.tipo;
            if (tipo === "A") {
                path = me.pathResource + "/a";
            } else {
                path = me.pathResource;
            }
            let link = process.env.VUE_APP_PATH_API + path + "/" + me.idDocumento;
            UtilityMixin.methods.restCallGet(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData.ordineOrigine = response.data.data;
            me.jsonData.anagrafica = me.jsonData.ordineOrigine.anagrafica;
            me.jsonData.idAnagrafica = me.jsonData.ordineOrigine.idAnagrafica;
            me.jsonData.tipo = me.trasformare;
            me.jsonData.ordineOrigine.listaRighe.forEach(() => {
                me.jsonData.listaRighe.push({ aliquotaIvaDescrizione: null });
            });
            // console.log(me.jsonData);

            me.$emit("afterLoadData");
            // me.jsonData.listaRighe.push({ aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
        },
        loadDataError(response) {
            console.log(response);
            this.$emit("afterLoadData");
        },
        onUpdateJsonData(data) {
            let me = this;
            let currentId = me.jsonData.id || me.id || data.id;

            me.jsonData = {
                ...data,
                id: currentId,
            };
            /* console.log(this.jsonData); */
            /* 
             console.log("jsonData aggiornato con ID:", currentId); */
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            // me.id = data.id;
            me.showModalLoading = false;
        },

        onAfterSave(data) {
            let me = this;
            me.id = data.id;
            let link = me.linkNotBack.replace("{editid}", "/edit/" + data.id);
            me.$router.push(link);
        },

        onActiveTab(idActiveTab) {
            let me = this;
            me.setCommand(idActiveTab);
        },
        setCommand(idActiveTab) {
            let me = this;
            me.btnNuovaPersonaRiferimento = true;
            me.btnNuovaRicetta = true;
            me.btnDatiFatturazione = true;
            me.btnNuovaImpegnativa = true;
            me.btnNuovoAllegatoA = true;
            me.btnSpesaExtra = true;
            switch (idActiveTab) {
                case "tbRsaPersoneRiferimento":
                    me.btnNuovaPersonaRiferimento = false;
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataPersoneRiferimento();
                    break;
                case "tbValutazioneIngresso":
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataSchedeValutazione();
                    /* console.log("TAB valutazione"); */
                    break;
                case "tbRsaRicette":
                    /* console.log("TAB Ricette"); */
                    me.btnNuovaRicetta = false;
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataRicette();
                    break;
                case "tbDatiFatturazione":
                    // console.log("TAB Fatturazione");
                    me.btnDatiFatturazione = false;
                    // me.$refs.cmpRsaAccettazioneEditComponent.setDatiFatturazione(me.jsonData);
                    break;
                case "tbRsaImpegnativa":
                    me.btnNuovaImpegnativa = false;
                    // me.$refs.cmpRsaAccettazioneEditComponent.setDataImpegnativa();
                    break;
                case "tbSchedaValutazioneAllegatoA":
                    me.btnNuovoAllegatoA = false;
                    break;
                case "tbSchedeValutazione":
                    me.$refs.cmpRsaAccettazioneEditComponent.loadDataSchedeValutazione();
                    /* console.log("TAB valutazione"); */
                    break;
            }
        },
        onClickNuovaPersonaRiferimento() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovaPersonaRiferimento();
        },
        onClickNuovaRicetta() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovaRicetta();
        },
        onClickNuoviDatiFatturazione() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuoviDatiFatturazione();
        },
        onClickNuovaImpegnativa() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovaImpegnativa();
        },
        onClickNuovoAllegatoA() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.onNuovoAllegatoA();
        },
        onTrasforma(row) {
            // console.log(row);
            let me = this;
            me.jsonData.listaRighe[row.index] = row.item;
            me.jsonData.ordineOrigine.listaRighe[row.index].trasformata = true;
            me.listKey++;
            // console.log(me.jsonData.ordineOrigine);

            me.calcolaTotali();
        },
        calcolaTotali() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/elabora";
            UtilityMixin.methods.restCallPost(path, me.jsonData, this.calcolaTotaliSuccessResponse, this.calcolaTotaliErrorResponse);
        },
        calcolaTotaliSuccessResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            // me.jsonData.listaRighe.push({ aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
        },

        calcolaTotaliErrorResponse(error) {
            console.log(error);
        },
    },
};
</script>
<style></style>
